import React from 'react'
import {get} from 'lodash'
import {Typography, Card, Switch, Grid} from '@material-ui/core'
import * as yup from 'yup'
import {Formik} from 'formik'
import {toast} from 'react-toastify'
import {
  FormikTextField,
  GridItem,
  GRID_CONTAINER_SPACING,
  SaveButton,
} from '../../storeSettings/components/common'

const validationSchema = yup.object({
  isOpen: yup.boolean().required(),
  timeToResume: yup.number().min(0).required('กรุณาใส่เวลาที่บอทจะกลับมาตอบลูกค้าที่มากกว่า 0'),
})

class AutoResume extends React.Component {
  render() {
    return (
      <Card style={{padding: '20px', marginBottom: '20px'}}>
        <Formik
          enableReinitialize
          initialValues={{
            isOpen: get(this.props, 'value.isOpen') || get(this.props, 'value.isOpen') === false ? get(this.props, 'value.isOpen') : true,
            timeToResume: get(this.props, 'value.timeToResume') || 15,
          }}
          onSubmit={(values, {setSubmitting}) => {
            this.props
              .onSave({
                variables: {
                  projectId: this.props.projectId,
                  botTimer: {
                    isOpen: values.isOpen,
                    timeToResume: Number(values.timeToResume),
                  },
                },
              })
              .then(re => {
                setSubmitting(false)
                toast.success(
                  'บันทึกข้อมูลการตั้งค่าบอทเรียบร้อยแล้ว',
                  {
                    hideProgressBar: true,
                    position: toast.POSITION.BOTTOM_RIGHT,
                  },
                )
              })
          }}
          validationSchema={validationSchema}
          render={props => {
            const {
              isSubmitting,
              handleSubmit,
              handleChange,
              handleBlur,
              touched,
              errors,
              values,
            } = props
            return (
              <form onSubmit={handleSubmit}>
                <Typography variant="title" style={{display: 'flex', justifyContent: 'space-between', marginBottom: '20px'}}>
                  Bot auto resume
                  <Switch
                    name="isOpen"
                    classes={(() => ({
                      bar: 'bg-deeple-purple-light',
                      iconChecked: 'toggle-deeple-purple-dark',
                    }))()}
                    checked={values.isOpen}
                    onBlur={handleBlur}
                    onChange={handleChange}
                  />
                </Typography>
                <Grid container spacing={GRID_CONTAINER_SPACING}>
                  <GridItem item xs={12} sm="auto">
                    <Typography align="center" variant="body1">
                      กำหนดเวลาที่บอทจะกลับมาทำงาน
                    </Typography>
                  </GridItem>
                  <GridItem item xs={12} sm={2}>
                    <FormikTextField
                      disabled={!values.isOpen}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      name="timeToResume"
                      label=""
                      fullWidth
                      value={values.timeToResume}
                      endAdornment="นาที"
                    />
                  </GridItem>
                  <Grid
                    container
                    direction="row-reverse"
                    spacing={GRID_CONTAINER_SPACING}
                  >
                    <GridItem item xs={12} sm={3}>
                      <SaveButton
                        type="submit"
                        variant="contained"
                        disabled={isSubmitting}
                        fullWidth
                      >
                      Save
                      </SaveButton>
                    </GridItem>
                  </Grid>
                </Grid>
              </form>
            )
          }}
        />
      </Card>
    )
  }
}

export default AutoResume



// WEBPACK FOOTER //
// ./src/main/content/project/ecommerce/aiSetting/component/AutoResume.js